/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, ContractFactory, Signer } from "ethers";
import { Provider } from "ethers/providers";
import { UnsignedTransaction } from "ethers/utils/transaction";

import { TransactionOverrides } from "..";
import { RewardPool } from "../RewardPool";

export class RewardPool__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(overrides?: TransactionOverrides): Promise<RewardPool> {
    return super.deploy(overrides) as Promise<RewardPool>;
  }
  getDeployTransaction(overrides?: TransactionOverrides): UnsignedTransaction {
    return super.getDeployTransaction(overrides);
  }
  attach(address: string): RewardPool {
    return super.attach(address) as RewardPool;
  }
  connect(signer: Signer): RewardPool__factory {
    return super.connect(signer) as RewardPool__factory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): RewardPool {
    return new Contract(address, _abi, signerOrProvider) as RewardPool;
  }
}

const _abi = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
  {
    inputs: [
      {
        internalType: "address payable",
        name: "patron",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "stakeAmount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "depositPeriod",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "patronRewardPortion",
        type: "uint256",
      },
    ],
    name: "payReward",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "stakeAmount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "depositPeriod",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "patronRewardPortion",
        type: "uint256",
      },
    ],
    name: "checkReward",
    outputs: [
      {
        internalType: "uint256",
        name: "reward",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";
